/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Retake_View_FrontInputs */

const en_us2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retake the front photo`)
};

const pt_br2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refazer a foto de frente`)
};

const es_419_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver a tomar la foto de frente`)
};

const pt_pt2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Repetir a foto de frente`)
};

const fr_fr2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprendre la photo de face`)
};

const de_de2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontfoto neu machen`)
};

const it_it2_body_assessment_retake_view_front = /** @type {(inputs: Body_Assessment_Retake_View_FrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifai la foto frontale`)
};

/**
* | output |
* | --- |
* | "Retake the front photo" |
*
* @param {Body_Assessment_Retake_View_FrontInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_retake_view_front = /** @type {((inputs?: Body_Assessment_Retake_View_FrontInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Retake_View_FrontInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_retake_view_front(inputs)
	if (locale === "es-419") return es_419_body_assessment_retake_view_front(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_retake_view_front(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_retake_view_front(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_retake_view_front(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_retake_view_front(inputs)
	return en_us2_body_assessment_retake_view_front(inputs)
});
export { body_assessment_retake_view_front as "body-assessment.retake_view_front" }